import React from 'react';

const ArrowLeft = ({ className }: { className?: string }) => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21.622 16">
			<path
				fill="currentColor"
				d="M.217 7.207a.132.132 0 00-.036.108.273.273 0 00-.072.144c0 .036-.036.072-.036.144 0 .036-.036.108-.036.144 0 .072-.036.144-.036.216v.144a.457.457 0 00.036.216c0 .072.036.108.036.144s.036.072.036.108c.036.072.072.108.108.18 0 .036.036.036.036.072.072.072.108.144.18.216l6.522 6.522a1.4524 1.4524 0 102.054-2.054L4.937 9.439h15.244a1.4415 1.4415 0 000-2.883H4.938L9.01 2.484A1.44 1.44 0 106.992.43L.433 6.989z"
			/>
		</svg>
	);
};

export default ArrowLeft;
